import React, { useState, useEffect } from "react";
import { validateToken, callApi } from "../../../lib/utils";
import CustomLoader from "../../GenericComponents/CustomLoader";
import moment from "moment";
import { useSelector } from "react-redux";
import axios from "axios";
import store from "../../../reducers/store";
import GenericTableFilterBar from "../../GenericComponents/GenericTableFilterBar";
import HRMHeader from "./HRMHeader";
import HRMList from "./HRMList";
import "../DrillDownPage.css";

function HRM() {
  const pages = useSelector((state) => state?.appstate?.pages);
  const [searchList, setSearchList] = useState([]);
  const [hrmEventsList, setHRMEventsList] = useState([]);
  const profileData = useSelector((state) => state?.dashboard);
  const currentPage = useSelector((state) => state?.tableFilter?.currentPage);
  const perPage = useSelector((state) => state?.tableFilter?.perPage);
  const [loading, setLoading] = useState(false);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);

  useEffect(() => {
    validateToken((err) => {
      if (err) {
        // console.log(err);
        window.location = "/logout";
      }
      fetchData();
    });
  }, [currentPage, perPage]);

  const setPagination = (data) => {
    store.dispatch({ type: "SET_PAGINATION_PAGES", payload: { pages: data } });
  };

  const fetchData = () => {
    let params = {
      start: startDate,
      end: endDate,
      page: currentPage,
      limit: parseInt(perPage),
      paginateResult: true,
      eventSubTypes: ["LTE", "HTE"],
      timezone: moment.tz.guess(),
    };

    setLoading(true);
    callApi(`/api/patient/dashboard/hrm/list`, params, "POST")
      .then((response) => {
        setHRMEventsList(response?.data?.data?.heartRateMonitoringEvents);
        setSearchList(response?.data?.data?.heartRateMonitoringEvents);
        setPagination(response?.data?.data?.pagination?.pages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const filterRecordsBySearchText = (searchText) => {
    let filteredList = [];
    searchList.forEach((list) => {
      let shouldAdd = true;
      if (
        list.minHeartRate.toUpperCase().search(searchText.toUpperCase()) ===
        -1
      ) {
        shouldAdd = false;
      }

      if (shouldAdd) {
        filteredList.push(list);
      }
    });
    setHRMEventsList(filteredList);
  };

  const exportFiles = (type) => {
    let params = {
      start: startDate,
      end: endDate,
      timezone: moment.tz.guess(),
      eventSubTypes: ["LTE", "HTE"],
    };
    setLoading(true);

    axios({
      method: "post",
      url: `/api/export/hrm/${profileData?.profileData?.id}/?export_type=${type}`,
      responseType: "blob",
      data: params,
    })
      .then((response) => {
        var filename = "";
        let disposition = null;

        if (Object.keys(response.headers).includes("content-disposition")) {
          disposition = response.headers["content-disposition"];
        } else if (
          Object.keys(response.headers).includes("Content-Disposition")
        ) {
          disposition = response.headers["Content-Disposition"];
        }

        // var disposition = xhr.getResponseHeader('Content-Disposition');
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        let blobData = response.data;
        setLoading(false);
        fileDownload(filename, blobData, type);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const fileDownload = (filename, blobData, type) => {
    var blobURL = window.URL.createObjectURL(blobData);
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute(
      "download",
      filename !== ""
        ? `${filename}`
        : type === "xlsx"
          ? "report.xlsx"
          : type === "csv" ? "report.csv" : "report.pdf"
    );

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  };

  return (
    <div className="drilldown-page">
      <CustomLoader loading={loading} />

      <HRMHeader />

      <GenericTableFilterBar pages={pages} title="" filterRecordsBySearchText={filterRecordsBySearchText} showPdfExportIcon={true}
        pdfExport={() => exportFiles("pdf")} />

      <HRMList currentPage={currentPage} perPage={perPage} hrmEventsList={hrmEventsList} />
    </div>
  );
}

export default HRM;
